import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';

interface IModalLegalProps {
  open: boolean;
  toggle: any;
}

export default function ModalNotCoverage(props: IModalLegalProps) {
  const { open = true, toggle } = props;

  return (
    <Modal modalClassName="format-new-modal" isOpen={open} size="lg" fade={false}>
      <div className="modal-header">
        <div className="close-modal-header w-100 d-flex text-align-left justify-content-between">
            <img
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_chevron.svg"
                alt=""
                onClick={toggle(false)}
            />
            <img 
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Action%20Group.svg"
                alt=""
                onClick={toggle(false)}
            />
        </div>
        <h4 className="modal-title px-20">Que no cubre</h4>
      </div>
      <ModalBody className="px-16">
        <p>Casos como:</p>
        <ul>
            <li>Medicamentos e insumos ambulatorios y hospitalarios.</li>
            <li>Enfermedades, dolencias o situaciones de salud conocidas o diagnosticadas antes de contratar el seguro.</li>
            <li>Cuando la fecha probable de inicio del embarazo, haya ocurrido con fecha anterior a la vigencia del seguro.</li>
        </ul>
        <p>Causas externas, como:</p>
        <ul>
            <li>Guerra internacional o civil, declarada o no declarada, invasión, acción de un enemigo extranjero, hostilidades.</li>
            <li>Epidemias.</li>
        </ul>
        <p>Tratamientos:</p>
        <ul>
            <li>Por adicción a las drogas, alcoholismo o tabaquismo.</li>
            <li>Fertilidad e infertilidad y esterilidad.</li>
        </ul>
        <p>Hospitalizaciones:</p>
        <ul>
            <li>Fuera de un recinto hospitalario y prestación de servicios de enfermería vinculados.</li>
            <li>A causa de enfermedades psiquiátricas y/o psicológicas.</li>
        </ul>
      </ModalBody>
    </Modal>
  );
}
